import {Model} from 'backbone';
export default Model.extend({
    idAttribute: 'uuid',
    defaults: {
        hasHeroImage: null,
        hasTeaserImage: null,
        large1x1Url: null,
        large16x9Url: null,
        large21x9Url: null,
        large36x25Url: null,
        medium1x1Url: null,
        medium16x9Url: null,
        medium21x9Url: null,
        medium36x25Url: null,
        modifiedData: false,
        modifiedPosition: false,
        newTeaser: false,
        position: null,
        publishedDate: null,
        small1x1Url: null,
        small16x9Url: null,
        small21x9Url: null,
        small36x25Url: null,
        large2x3Url: null,
        medium2x3Url: null,
        small2x3Url: null,
        sponsored: false,
        storyUuid: null,
        summary: null,
        teaserListUuid: null,
        title: null,
        url: null,
        validTeaserLists: [], // array of teaserListUuids
        videoThumbUrl: null,
        videoUrl: null,
    },
    toTemplateJSON() {
        return Object.assign({modified: this.get('modifiedData') || this.get('modifiedPosition')}, this.toJSON());
    },
});
